import * as yup from 'yup';

export const getDocumentSchema = (t: (key: string) => string) =>
  yup.object({
    name: yup.string().required(t('errors.required')),
    stamped: yup.boolean().required(t('errors.required')),
    comment: yup.string().optional().nullable(),
  });

export const getUploadDocumentSchema = (_t: (key: string) => string) =>
  yup.object({
    files: yup.array().of(
      yup.object({
        file: yup.mixed().required(),
        stamped: yup.boolean(),
        comment: yup.string().optional().nullable(),
        pointOfSaleId: yup.string().optional().nullable(),
        documentType: yup.string().optional().nullable(),
        ticketId: yup.string().optional().nullable(),
      }),
    ),
  });
